module.exports = __webpack_public_path__ + "img/icon-dyjy.5dcd34e0.png";